import $ from "jquery";
import { initCards } from "../cards";
import initSlides from "../slide_decks/add_to_slide_deck";
import initPrint from "../print_links";
import initPermalink from "../permalink_modal";

const tariffSurveyHubPageRefresh = function (newHtml) {
  window.Highcharts.charts.forEach(function (chart) {
    if (chart) { chart.destroy(); }
  });
  window.Chartkick.charts = [];

  // TODO(SI): figure out a cleaner way of removing the leaflet map.
  // plain .remove() DOES NOT work. See: https://github.com/Leaflet/Leaflet/issues/2718
  window.tariffMap.removeProperly();
  window.tariffMap = null;

  $("#tariff-survey-chart-container .effective-datatable").DataTable().destroy();

  $("#tariff-survey-chart-container").html(newHtml);
  $("#tariff-survey-chart-container .effective-datatable").DataTable();

  const refresh = () => {
    initCards();
    initSlides();
    initPrint();
    initPermalink();
    $(window).trigger("resize");
  };

  refresh();

  $(".data-hub-searching-overlay").addClass("hidden");
};

export default tariffSurveyHubPageRefresh;
